/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Recover_SendInputs */



/**
* | output |
* | --- |
* | "Send New Link" |
*
* @param {Login_Recover_SendInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_recover_send = /** @type {((inputs?: Login_Recover_SendInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Recover_SendInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer un nouveau lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar enlace nuevo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar Novo Link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia Nuovo Link")
	return /** @type {LocalizedString} */ ("Send New Link")
});